import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AssetActions from "../../../store/actions/Assets";
import { getInitialState, isValNull } from "../../../utils";
import { filterObj } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import variables from "../../../constants/assets/variables";
import Textarea from "sushiweb/InputTypes/Textarea";
const disabledFieldsInEditState = ["id", "is_active"];


const statusOptions = [
  { key: true, label: "Active" },
  { key: false, label: "In Active" },
];

const UPCQrOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" },
];

export const AssetsFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeId,
    activeAsset,
    assetList,
    activeFilters,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.ASSET_MANAGEMENT];
  const [toggleStatus, setToggleStatus] = useState(true);
  const [upcQrToggleStatus, setUPCQrToggleStatus] = useState(false);
  const [initialState, setInitialState] = useState({
    id: "",
    name: "",
    amount: 0,
    chargeable_amount: 0,
    is_active: true,
    icon_image: "",
    images: "",
    upc_qr: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = filterObj(initialState, [
      "id",
      "name",
      "amount",
      "chargeable_amount",
      "icon_image",
      "images",
      "is_active",
      "upc_qr",
    ]);

    props.createOrUpdateAsset(body).then((res) => {
      props.getAssetList();
      handleClose();
    });
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleStatusChange = (key, val) => {
    const values = { ...initialState };
    values["is_active"] = val;
    setToggleStatus(val);
    setInitialState(values);
  };

  const handleUPCQrStatusChange = (key, val) => {
    const values = { ...initialState };
    values["upc_qr"] = val;
    setUPCQrToggleStatus(val);
    setInitialState(values);
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const checkIfDisabled = (key) => {
    if (modalState === "Edit") {
      return disabledFieldsInEditState.includes(key) ? true : false;
    } else {
      return false;
    }
  };

  const getRequiredButtonPerms = (action = undefined) => {
    if (modalState === "Edit") {
      return [allActions.ASSET_MANAGEMENT];
    } else if (modalState === "Add") {
      return [allActions.ASSET_MANAGEMENT];
    }
    return undefined;
  };

  useEffect(() => {
    if (activeId) {
      props.getAsset(activeId, assetList);
    }
  }, [activeId, modalState]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeAsset && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeAsset[key]
          ? activeAsset[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }

    setToggleStatus(activeAsset.is_active);
    setUPCQrToggleStatus(activeAsset.upc_qr);
  }, [activeAsset, activeFilters]);

  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };

  return (
    <>
      <NoFooterModal
        header={true}
        heading={`${modalState} Asset`}
        handleClose={handleClose}
        id="PropertiesFormModal"
        modalButtons={getModalButtons()}
      >
        {modalState === "Edit" && (
          <Input
            value={initialState.id}
            data-testid="id"
            id="sushi-input"
            disabled={checkIfDisabled("id")}
            onChange={(e) => handleChange("id", e)}
            label="ID"
          />
        )}
        {(modalState === "Edit" || modalState === "Add") && (
          <Input
            value={initialState.name}
            data-testid="name"
            id="sushi-input"
            disabled={checkIfDisabled("name")}
            onChange={(e) => handleChange("name", e)}
            label="Name"
          />
        )}

        {(modalState === "Edit" || modalState === "Add") && (
          <Input
            value={initialState.amount}
            data-testid="amount"
            id="sushi-input"
            disabled={checkIfDisabled("amount")}
            onChange={(e) => handleChange("amount", e)}
            label="Amount"
          />
        )}

        {(modalState === "Edit" || modalState === "Add") && (
          <Input
            value={initialState.icon_image}
            data-testid="icon_image"
            id="sushi-input"
            disabled={checkIfDisabled("icon_image")}
            onChange={(e) => handleChange("icon_image", e)}
            label="Icon"
          />
        )}

        {(modalState === "Edit" || modalState === "Add") && (
          <>
            <Input
              value={initialState.images}
              data-testid="images"
              id="sushi-input"
              disabled={checkIfDisabled("images")}
              onChange={(e) => handleChange("images", e)}
              label="Images"
            />
            <p className="mb-20 ml-12 opacity-5 text-grey">
              <b>Final images to be sent:</b>
            </p>
            <Textarea
              id="sushi-textarea"
              data-testid="images"
              borderColor={variables.primaryColor}
              innerWidth="100%"
              className="mb-20"
              resize="none"
              label="Images"
              disabled={true}
              value={initialState.images}
            />
          </>
        )}

        {(modalState === "Edit" || modalState === "Add") && (
          <Input
            value={initialState.chargeable_amount}
            data-testid="chargeable_amount"
            id="sushi-input"
            disabled={checkIfDisabled("chargeable_amount")}
            onChange={(e) => handleChange("chargeable_amount", e)}
            label="Chargeable Amount"
          />
        )}

        {modalState === "Edit" && (
          <PaginatedReactDropdown
            options={statusOptions}
            data-testid="isActive"
            labelKey="label"
            valueKey="key"
            labelWidth="10%"
            disabled={checkIfDisabled("is_active")}
            value={getInputLabel(toggleStatus, statusOptions, "key", "label")}
            handleChange={handleStatusChange}
            keyToChange="toggleStatus"
            placeholder="Is Active"
            showCross={false}
            id="isActive"
          />
        )}

        {(modalState === "Edit" || modalState === "Add") && (
          <PaginatedReactDropdown
            options={UPCQrOptions}
            data-testid="upcQR"
            labelKey="label"
            valueKey="key"
            labelWidth="10%"
            disabled={checkIfDisabled("upc_qr")}
            value={getInputLabel(
              upcQrToggleStatus,
              UPCQrOptions,
              "key",
              "label"
            )}
            handleChange={handleUPCQrStatusChange}
            keyToChange="upcQRToggleStatus"
            placeholder="UPC QR"
            showCross={false}
            id="upcQR"
          />
        )}
      </NoFooterModal>
    </>
  );
};

function mapStateToProps(state) {
  const { Asset } = state;
  return {
    assetList: Asset.assetList,
    activeAsset: Asset.activeAsset,
    activeFilters: Asset.activeFilters,
    currentPage: Asset.currentPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createOrUpdateAsset: bindActionCreators(
      AssetActions.createOrUpdateAsset,
      dispatch
    ),
    getAssetList: bindActionCreators(AssetActions.getAssetList, dispatch),
    getAsset: bindActionCreators(AssetActions.getAsset, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetsFormModal);
